export const messages = {
  en: {
    addOwnerCommittee: {
      title: 'Add Owner Committee',
      name: 'Name',
      sex: 'Gender',
      phone: 'Phone',
      idCard: 'ID Card',
      address: 'Address',
      position: 'Position',
      post: 'Post',
      postDesc: 'Post Description',
      appointTime: 'Appointment Term',
      curTime: 'Current Term',
      state: 'Status',
      remark: 'Remark',
      emergencyContact: 'Emergency Contact',
      contactRelationship: 'Relationship',
      contactName: 'Name',
      contactPhone: 'Phone',
      contactAddress: 'Address',
      male: 'Male',
      female: 'Female',
      onJob: 'On Job',
      leaveJob: 'Leave Job',
      requiredName: 'Required, please fill in name',
      requiredSex: 'Required, please select gender',
      requiredPhone: 'Required, please fill in phone',
      requiredIdCard: 'Required, please fill in ID card',
      requiredAddress: 'Required, please fill in address',
      requiredPosition: 'Required, please fill in position',
      requiredPost: 'Required, please fill in post',
      optionalPostDesc: 'Optional, please fill in post description',
      requiredAppointTime: 'Required, please fill in appointment term',
      requiredCurTime: 'Required, please fill in current term',
      requiredState: 'Required, please select status',
      optionalRemark: 'Optional, please fill in remark',
      requiredRelationship: 'Required, please fill in relationship',
      maxName: 'Name cannot exceed {max} characters',
      maxSex: 'Gender cannot exceed {max} characters',
      maxPhone: 'Phone cannot exceed {max} characters',
      maxIdCard: 'ID card cannot exceed {max} characters',
      maxAddress: 'Address cannot exceed {max} characters',
      maxPosition: 'Position cannot exceed {max} characters',
      maxPost: 'Post cannot exceed {max} characters',
      maxPostDesc: 'Post description cannot exceed {max} characters',
      maxAppointTime: 'Appointment term cannot exceed {max} characters',
      maxCurTime: 'Current term cannot exceed {max} characters',
      maxState: 'Status cannot exceed {max} characters',
      maxRemark: 'Remark cannot exceed {max} characters',
      saveSuccess: 'Save successfully',
      saveError: 'Save failed'
    }
  },
  zh: {
    addOwnerCommittee: {
      title: '添加业委会',
      name: '姓名',
      sex: '性别',
      phone: '电话',
      idCard: '身份证号码',
      address: '住址',
      position: '职位',
      post: '岗位',
      postDesc: '岗位描述',
      appointTime: '届期',
      curTime: '任期',
      state: '状态',
      remark: '备注',
      emergencyContact: '紧急联系人',
      contactRelationship: '成员关系',
      contactName: '姓名',
      contactPhone: '联系电话',
      contactAddress: '住址',
      male: '男',
      female: '女',
      onJob: '在职',
      leaveJob: '离职',
      requiredName: '必填，请填写姓名',
      requiredSex: '必填，请选择性别',
      requiredPhone: '必填，请填写电话',
      requiredIdCard: '必填，请填写身份证号码',
      requiredAddress: '必填，请填写住址',
      requiredPosition: '必填，请填写职位',
      requiredPost: '必填，请填写岗位',
      optionalPostDesc: '选填，请填写岗位描述',
      requiredAppointTime: '必填，请填写届期',
      requiredCurTime: '必填，请填写任期',
      requiredState: '必填，请选择状态',
      optionalRemark: '选填，请填写备注',
      requiredRelationship: '必填，请填写关系',
      maxName: '姓名不能超过{max}个字符',
      maxSex: '性别不能超过{max}个字符',
      maxPhone: '电话不能超过{max}个字符',
      maxIdCard: '身份证号码不能超过{max}个字符',
      maxAddress: '住址不能超过{max}个字符',
      maxPosition: '职位不能超过{max}个字符',
      maxPost: '岗位不能超过{max}个字符',
      maxPostDesc: '岗位描述不能超过{max}个字符',
      maxAppointTime: '届期不能超过{max}个字符',
      maxCurTime: '任期不能超过{max}个字符',
      maxState: '状态不能超过{max}个字符',
      maxRemark: '备注不能超过{max}个字符',
      saveSuccess: '保存成功',
      saveError: '保存失败'
    }
  }
}